import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class SourcesIcon extends PureComponent {
  static propTypes = {
    fill: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    fill: 'currentColor',
    size: '24px'
  }

  render() {
    const { size, fill } = this.props
    return (
      <svg width={size} height={size} viewBox="0 0 24 24">
        <path
          d="M20.586 13H8a1 1 0 0 1 0-2h12.586l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a.997.997 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L20.586 13zM15.76 2.73A10.018 10.018 0 0 0 12 2a9.964 9.964 0 0 0-7.071 2.929c-3.906 3.905-3.906 10.237 0 14.142A9.964 9.964 0 0 0 11.999 22c1.29 0 2.567-.247 3.76-.73a1 1 0 1 1 .752 1.853c-1.434.58-2.966.877-4.511.877a11.963 11.963 0 0 1-8.486-3.515c-4.686-4.686-4.686-12.284 0-16.97A11.963 11.963 0 0 1 12 0c1.545 0 3.077.296 4.51.877a1 1 0 1 1-.75 1.854z"
          fill={fill}
        />
      </svg>
    )
  }
}
